import { render } from "./narvar_ingles.vue?vue&type=template&id=3bb0427c&scoped=true"
import script from "./narvar_ingles.vue?vue&type=script&lang=js"
export * from "./narvar_ingles.vue?vue&type=script&lang=js"

import "./narvar_ingles.vue?vue&type=style&index=0&id=3bb0427c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb0427c"]])

export default __exports__